module.exports = __webpack_public_path__ + "static/media/event_log.e230d3da.svg";